import { useQuery } from 'react-query';
import type { PlaceLocation } from '@goodfynd/context';

import config from '../config';
import type { VendorFrequentLocationsResponse } from '../services/api/types';

import { useVendorApi } from './api';

type Options = {
  vendorId?: string;
};
export default function useVendorFrequentLocations({ vendorId }: Options = {}) {
  const api = useVendorApi();
  const { data, isFetched, isFetching, isLoading, refetch } = useQuery<
    VendorFrequentLocationsResponse,
    any
  >(
    [config.queryKeys.vendorFrequentLocations, vendorId],
    () => api.getFrequentLocations(vendorId!),
    {
      enabled: !!vendorId,
    }
  );

  return {
    isFetched,
    isFetching,
    isLoading,
    refetch,
    frequentLocations: data?.results ?? ([] as PlaceLocation[]),
  };
}
